import BarChartIcon from "@mui/icons-material/BarChart";
import { MenuItem } from "@mui/material";
import { type FC } from "react";
import { matchPath, NavLink, useLocation } from "react-router";

import { MoreButton } from "~/components/UI/MoreButton";
import { ROUTES } from "~/constants/routing";
import { renderBadge } from "~/feature/categories/components/Categories/utils";
import * as Styled from "~/feature/categories/components/MoreTagsButton/MoreTagsButton.styles";

import { useIndicesTabs } from "./useIndicesTab";

export const MoreIndicesButton: FC = () => {
  const indicesTabs = useIndicesTabs();
  const { pathname } = useLocation();
  const isActive = !!matchPath(
    { path: ROUTES.warIndex.path, end: false },
    pathname
  );

  return (
    <MoreButton
      text="Indices"
      startIcon={<BarChartIcon fontSize="small" />}
      arrowIcon={false}
      component={NavLink}
      to={ROUTES.warIndex.createURL()}
      isActive={isActive}
    >
      {indicesTabs.map((tab) => {
        const TabIcon = tab.icon;

        return (
          <MenuItem
            key={tab.key}
            component={NavLink}
            to={tab.to}
            selected={tab.isActive}
            sx={{ gap: 0.5 }}
          >
            {!!TabIcon && <TabIcon fontSize="small" />}
            <Styled.CategoryText variant="caption" $isActive={tab.isActive}>
              {tab.label}
            </Styled.CategoryText>
            {renderBadge(tab.key)}
          </MenuItem>
        );
      })}
    </MoreButton>
  );
};
